import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-park_right",
  "use": "icon-park_right-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-park_right\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h28v28H0z\" /><path fill=\"#0078FF\" d=\"M15.367 14 9.592 8.225l1.65-1.65L18.667 14l-7.425 7.425-1.65-1.65z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol